import React from "react";
import { Plus } from "lucide-react";

interface AddItemIconProps {
  onClick: () => void;
  // merged over the base circle style — e.g. absolute positioning on a row
  style?: React.CSSProperties;
}

// Small circled + for adding an item. Sized inline rather than with
// .circle-button, whose !important 36px size inline styles can't override.
const baseStyle: React.CSSProperties = {
  width: 20,
  height: 20,
  flexShrink: 0,
  borderRadius: "50%",
  // same grey as the row's pencil / trash icons; the + inherits it
  border: "2px solid #888",
  color: "#888",
  background: "white",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
};

const AddItemIcon: React.FC<AddItemIconProps> = ({ onClick, style }) => (
  <div style={{ ...baseStyle, ...style }} onClick={onClick}>
    <Plus  />
  </div>
);

export default AddItemIcon;
